import './style.scss';
import '../styles/scss/helpers/_media-queries.scss';
import PageRenderer from '../components/page-renderer';

function App() {
	return <PageRenderer />;
}

export default App;
